import React, { Component } from 'react';

class FormCheckboxField extends Component {
    render() {
        const { id, label, helpText, checked, onChange, children } = this.props;
        return (
            <div className="form-checkbox-field">
                <div className="form-group">
                    <label htmlFor={id}>{label}</label>
                    {helpText && <p className="form-help-text">{helpText}</p>}
                    <input type="checkbox" checked={checked} id={id} name={id} onClick={onChange}/>
                </div>
                {checked && children && (
                    <div className="form-checkbox-field-children">
                        {children}
                    </div>
                )}
            </div>
        );
    }
}

export default FormCheckboxField;
